import { cx } from "@linaria/core";
import type { ReactNode } from "react";

import * as styles from "./show-for.style";
import { Breakpoint } from "../css/maker.breakpoints";
import { units } from "../css-tokens/units";
import { useMatchMedia } from "../hooks/match-media";

type Props = {
  className?: string;

  breakpoint: Breakpoint;
  children: ReactNode;

  immediate?: boolean;
};

export function ShowFor(props: Props): React.JSX.Element | null {
  const matches = useMatchMedia(props.breakpoint.toQuery(), {
    immediate: props.immediate,
  });

  switch (matches) {
    case true:
      return (
        <div data-show-for={false} className={props.className}>
          {props.children}
        </div>
      );

    case false:
      return null;

    default:
      return (
        <div
          data-show-for={true}
          className={cx(styles.ssrContainer, props.className)}
          style={styles.tokens.__override({
            from: units.px(props.breakpoint.from ?? 0),
            to: units.px(props.breakpoint.to ?? 100000),
          })}
        >
          {props.children}
        </div>
      );
  }
}
